
export const FeaturesModule = {
  namespaced: true,
  state: {
    flags: {},
  },
  actions: {
    setEnabled (context, payload) {
      context.commit('setEnabled', payload)
    },
    clear (context, flagId) {
      context.commit('clear', flagId)
    },
  },
  mutations: {
    setEnabled: (state, payload) => {
      const flagId = payload.flagId
      const enabled = payload.enabled
      state.flags[flagId] = enabled
    },
    clear: (state, flagId) => {
      state.flags[flagId] = undefined
    },
  },
  getters: {
    enabled: state => {
      return flagId => {
        return state.flags[flagId]
      }
    },
    isSetLocally: state => {
      return flagId => {
        return flagId in state.flags
      }
    },
  },
}
